import { render, staticRenderFns } from "./HomeBase.vue?vue&type=template&id=4e130946&scoped=true&"
import script from "./HomeBase.vue?vue&type=script&lang=js&"
export * from "./HomeBase.vue?vue&type=script&lang=js&"
import style0 from "./HomeBase.vue?vue&type=style&index=0&id=4e130946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e130946",
  null
  
)

export default component.exports